import React, { useState } from 'react';
import Uppy from '@uppy/core';
import { UppyContextProvider } from '@uppy/react';
import AwsS3 from '@uppy/aws-s3';
import DropTarget from '@uppy/drop-target';
import ThumbnailGenerator from '@uppy/thumbnail-generator';

import {
  APIupdateAsset,
  APIdeleteAsset,
} from '../../api/Assets';

import Dropzone from './Dropzone';

import {
  getFileMetadata,
  isImageType,
} from '../../helpers/file';

import '@uppy/core/css/style.css';
import '@uppy/react/css/style.css';

interface TimelineCreateFilesProps {
  addFile: Function;
  removeFile: Function;
  setUploading: Function;
  setFiles: Function;
  children?: React.ReactNode;
}

const TimelineCreateFiles: React.FC<TimelineCreateFilesProps> = ({
  addFile,
  removeFile,
  setUploading,
  setFiles,
  children,
}) => {
  const [progress, setProgress] = useState(0);

  const uploading = progress > 0 && progress < 100;

  const [uppy] = useState(() => new Uppy({
    autoProceed: true,
    restrictions: {
      allowedFileTypes: ['.jpg', '.jpeg', '.png', '.mp4', '.mov', '.avi', '.mp3', '.wav'],
      // maxNumberOfFiles: 25,
    },
  })
  .on('file-removed', (file) => {
    APIdeleteAsset(file.meta.uuid as string);
    removeFile(file.meta.uuid);
    setFiles(uppy.getFiles());
  })
  .on('file-added', () => {
    setFiles(uppy.getFiles());
  })
  .on('progress', (progress) => {
    setProgress(Math.round(progress));
    setFiles(uppy.getFiles());
  })
  .on('upload', () => {
    setUploading(true);
    setProgress(1);
  })
  .on('upload-progress', () => {
    setFiles(uppy.getFiles());
  })
  .on('upload-success', async (file) => {
    if (file) {
      const metadata = isImageType(file.type) ? await getFileMetadata(file.data as File) : {};
      APIupdateAsset(file.meta.uuid as string, {
        status: 'uploaded',
        metadata,
      });
      uppy.setFileMeta(file.id, { ...file.meta, ...metadata });
      addFile({ ...file.meta, metadata });
    }
    setFiles(uppy.getFiles());
    setUploading(false);
  })
  .on('upload-error', () => {
    setFiles(uppy.getFiles());
    setUploading(false);
  })
  .on('thumbnail:generated', () => {
    setFiles(uppy.getFiles());
  })
  .use(ThumbnailGenerator, {
    thumbnailType: 'image/png',
  })
  .use(AwsS3, {
   shouldUseMultipart: false,
    getUploadParameters: async (file) => {
      return window.axios('/api/assets/upload', {
        method: 'post',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
        },
        data: JSON.stringify({
          filename: file.name,
          contentType: file.type,
          size: file.size,
        }),
      })
        .then((response) => {
          return response.data;
        })
        .then((data) => {
          uppy.setFileMeta(file.id, {...data.fields});

          return {
            method: data.method,
            url: data.url,
            fields: data.fields,
            headers: data.headers,
          }
        });
    },
  })
  .use(DropTarget, {
    target: document.getElementById('lgcy-app') as HTMLElement,
  }));

  return (
    <div className="timeline-create-files-container">
      <div className="timeline-create-files">
        <UppyContextProvider uppy={uppy}>
          <div className="timeline-create-files-uploader">
            <Dropzone uploading={uploading} progress={progress} />
            {children}
          </div>
        </UppyContextProvider>
      </div>
    </div>
  );
}

export default TimelineCreateFiles;
